import styles from "./activity-indicator.module.css";
import classNames from "classnames";

interface ActivityIndicatorProps {
  text?: string;
  labelStyle?: "inline" | "block";
  size?: "small" | "medium" | "large";
}

export const ActivityIndicator = ({
  text,
  labelStyle = "block",
  size = "medium",
}: ActivityIndicatorProps) => {
  let sizeClass = "";
  let textSizeClass = "";
  switch (size) {
    case "small":
      sizeClass = styles.small;
      textSizeClass = styles.textSmall;
      break;
    case "medium":
      sizeClass = styles.medium;
      textSizeClass = styles.textMedium;
      break;
    case "large":
      sizeClass = styles.large;
      textSizeClass = styles.textLarge;
      break;
  }

  return (
    <div
      className={
        labelStyle === "block" ? styles.container : styles.containerInline
      }
    >
      <span className={classNames(styles.loaderSpinning, sizeClass)}></span>
      {text && (
        <span className={classNames(styles.text, textSizeClass)}>{text}</span>
      )}
    </div>
  );
};
